import type { FC } from 'react';

import Tooltip from '@lokalise/ui/components/Tooltip';

import Button from '../../Button';
import Modal from '../Modal';
import ModalActions from '../components/ModalActions';
import type { ModalProps } from '../types';

interface ConfirmModalProps extends ModalProps {
    confirmText: string;
    loading?: boolean;
    closeText?: string;
    onConfirm: () => void;
    tooltipTitle?: string;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
    children,
    confirmText,
    closeText = 'Close',
    loading = false,
    onClose,
    onConfirm,
    tooltipTitle,
    ...restProps
}) => (
    <Modal onClose={onClose} {...restProps}>
        {children}
        <ModalActions>
            <Button appearance="primary" variant="outline" onClick={onClose}>
                {closeText}
            </Button>
            <Tooltip popoverContent={tooltipTitle} showPopover={!!tooltipTitle} placement="top">
                <Button appearance="primary" variant="solid" loading={loading} onClick={onConfirm}>
                    {confirmText}
                </Button>
            </Tooltip>
        </ModalActions>
    </Modal>
);

export default ConfirmModal;
